// Imports Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/** @namespace GestorFirmasComponent */
import { GestorFirmasComponent } from './components/gestor-firmas/gestor-firmas.component';
/** @namespace SelectorComponent */
import { SelectorComponent } from './components/selector/selector.component';

/**
 * Routes associated to components
 * @constant
 * @type {Array<JSON>}
 */
const routes: Routes = [
    { path: '', component: SelectorComponent },
    { path: 'gestor-firmas', component: GestorFirmasComponent },
    { path: 'selector', component: SelectorComponent }
];

/** @module NgModule main app */
@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})

/**
* Module main app routing
* @class
*/
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/app-routing.module.ts